import { createI18n } from 'vue-i18n';
import en from './locales/en';
import cn from './locales/cn';

/**
 * Map an incoming language code to a supported locale.
 * Anything starting with "zh" (zh-CN, zh-TW, ...) or "cn" -> Chinese, else English.
 */
export function resolveLocale(lang) {
    if (!lang) return 'en';
    const l = String(lang).toLowerCase();
    return l.startsWith('zh') || l === 'cn' ? 'cn' : 'en';
}

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en, cn }
});

/** Set the active locale, normalizing the input language code first. */
export function setLocale(lang) {
    i18n.global.locale.value = resolveLocale(lang);
}

export default i18n;
